<template>
  <n-modal class="error-request" :loading="$var('load')" @close="$emit('close')">
    <h3>Сообщить об ошибке</h3>
    <n-form @submit="submit">
      <n-items>
        <n-input title="Описание проблемы" v-bind="$form.input('body')" />
        <n-button type="submit">Отправить</n-button>
      </n-items>
    </n-form>
  </n-modal>
</template>

<script>
export default {
  name: 'ErrorRequest',
  created() {
    this.$form.init({
      body: '',
    })
  },
  methods: {
    submit() {
      this.$var('load', true)
      $api.iq.error.post(this.$form.get()).then((response) => {
        this.$emit('close')
      }).finally(() => {
        this.$var('load', false)
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.error-request {

}
</style>
